/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Container, Card } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types';
import { useTheme } from '@mui/material/styles';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};

export default function DeductionTemplateListing(props) {
  const screenCode = 'DEDUCTIONTEMPLATE';
  let encrypted = '';
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    groupID: '0',
    operationEntityID: '0'
  });
  const [groupList, setGroupList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    operationEntityID: Yup.number()
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      GetAllDeductionTemplateData(values.groupID, values.operationEntityID);
    }
  });

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const storedDeductionTemplateData = JSON.parse(sessionStorage.getItem('deductionTemplateData'));
    const storedPage = JSON.parse(sessionStorage.getItem('deductionTemplatePage'));
    getPermissions(storedDeductionTemplateData, storedPage);
    sessionStorage.removeItem('deductionTemplateData');
    sessionStorage.removeItem('deductionTemplatePage');
  }, []);

  async function getPermissions(storedDeductionTemplateData, storedPage) {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWDEDUCTIONTEMPLATE');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });
    const isInitialLoading = storedDeductionTemplateData === null;
    if (isInitialLoading) {
      setValues({
        ...values,
        groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
      });
    } else {
      setValues({
        ...values,
        groupID: parseInt(storedDeductionTemplateData.groupID),
        operationEntityID: parseInt(storedDeductionTemplateData.operationEntityID)
      });
      trackPromise(
        GetAllDeductionTemplateData(
          storedDeductionTemplateData.groupID,
          storedDeductionTemplateData.operationEntityID
        )
      );

      if (storedPage !== null) {
        setPage(storedPage);
      }
    }

    trackPromise(GetAllGroups());
  }

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  useEffect(() => {
    setTableData([]);
  }, [formik.values.operationEntityID]);

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  async function GetAllDeductionTemplateData(groupID, operationEntityID) {
    var res = await services.GetAllDeductionTemplateData(groupID, operationEntityID);
    if (res != null) {
      setTableData(res);
    }
  }

  function generateGroupForDropDownMenu(data) {
    let items = [];
    if (data != null) {
      data.forEach((x) => {
        items.push(
          <MenuItem key={x.groupID} value={x.groupID}>
            {x.groupName}
          </MenuItem>
        );
      });
    }
    return items;
  }

  async function clearAll() {
    sessionStorage.removeItem('deductionTemplateData');
    sessionStorage.removeItem('deductionTemplatePage');
    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    });
    setTableData([]);
  }

  function handleClick(datas) {
    sessionStorage.setItem('deductionTemplateData', JSON.stringify(values));
    sessionStorage.setItem('deductionTemplatePage', JSON.stringify(page));
    encrypted = AESEncryptionParam(datas.deductionTemplateID.toString());
    navigate('/dashboard/deductiontemplate/AddEdit/' + encrypted);
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Deduction Template |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/dashboard/deductiontemplate/AddEdit/' + AESEncryptionParam('0')}
            btname="Add"
            pageName="Deduction Template"
          />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={4}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Group
                    </MenuItem>
                    {generateGroupForDropDownMenu(groupList)}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Operation Entity *"
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      All Fresh Collection Centers
                    </MenuItem>
                    {operationEntityList.map((option) => (
                      <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button
                      type="button"
                      color="error"
                      variant="outlined"
                      onClick={() => clearAll()}
                    >
                      {' '}
                      Clear
                    </Button>
                    <Button type="submit" color="secondary" variant="outlined">
                      Search
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Form>
          </FormikProvider>
          <br />
          <Divider variant="middle" />
          <br />
          {tableData.length == 0 ? (
            <SearchNotFound searchQuery="Deduction Template" />
          ) : (
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Card style={{ justifycontent: 'center', width: '85rem' }}>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Deduction Type</TableCell>
                        <TableCell align="center">Apply Method</TableCell>
                        <TableCell align="center">Deduction Method</TableCell>
                        <TableCell align="center">Deduction Order</TableCell>
                        <TableCell align="center">Deduction Sequence</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowsPerPage > 0
                        ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : tableData
                      ).map((row) => (
                        <TableRow key={row.deductionTemplateID}>
                          <TableCell align="center" component="th" scope="row">
                            {row.deductionTypeName}
                          </TableCell>
                          <TableCell align="center">
                            {row.applyMethodID == 1
                              ? 'Percentage'
                              : row.applyMethodID == 2
                              ? 'Flat'
                              : 'All'}
                          </TableCell>
                          <TableCell align="center" component="th" scope="row">
                            {row.isFixed == true
                              ? 'Fixed'
                              : row.isDefaultValueEnabled == true
                              ? 'Default'
                              : '-'}
                          </TableCell>
                          <TableCell align="center">{row.deductionOrder}</TableCell>
                          <TableCell align="center">{row.deductionSequence}</TableCell>
                          <TableCell align="center">
                            {row.isActive ? (
                              <Chip size="small" label="Active" style={{ color: 'green' }} />
                            ) : (
                              <Chip size="small" label="Inactive" style={{ color: 'red' }} />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {
                              <IconButton aria-label="delete" onClick={() => handleClick(row)}>
                                <EditIcon />
                              </IconButton>
                            }
                          </TableCell>
                        </TableRow>
                      ))}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          colSpan={6}
                          count={tableData.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: {
                              'aria-label': 'rows per page'
                            },
                            native: true
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Card>
            </Stack>
          )}
        </Container>
      </Page>
    </>
  );
}
